import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button, Container } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import { base_url, ImageUrl, postHeader } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Heading from "../ui/Heading";
import { isDesktop, isMobile } from "react-device-detect";
import googleImg from "../../../../../Assets/nokaoi-imges/google-reviews.jpg";
import yelpImg from "../../../../../Assets/nokaoi-imges/yelp-reviews.jpg";
import { tr } from "date-fns/locale";
import leftArrow from '../../../../../Assets/nokaoi-imges/left-arrow.png'
import rightArrow from '../../../../../Assets/nokaoi-imges/right-arrow.png'
const Customer = () => {
  const [customerData, setCustomerData] = useState([]);

  const GetCustomerRewies = useCallback(() => {
    axios
      .get(`${base_url}/common/site_reviews`, { headers: postHeader })
      .then(({ data }) => {
        if (data.status === 1) {
          setCustomerData(data.data);
        }
      })
      .catch((error) => console.error("Error fetching reviews:", error));
  }, []);

  useEffect(() => {
    GetCustomerRewies();
  }, [GetCustomerRewies]);

  // 🔥 Fix `aria-hidden` and `tabindex`
  const updateTabIndex = () => {
    setTimeout(() => {
      document.querySelectorAll(".slick-slide").forEach((slide) => {
        const isHidden = slide.getAttribute("aria-hidden") === "true";
        console.log(`Slide ${slide.getAttribute("data-index")} hidden:`, isHidden); // Debugging Log

        slide.querySelectorAll("a, button, input").forEach((el) => {
          if (isHidden) {
            el.setAttribute("tabindex", "-1");
          } else {
            el.removeAttribute("tabindex");
          }
        });
      });
    }, 100);
  };

  const settings2 = {
    accessibility: true,
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <LazyLoadImage src={leftArrow} alt="arrow" />,
    nextArrow: <LazyLoadImage src={rightArrow} alt="arrow" />,
    responsive: [
      { breakpoint: 1479, settings: { dots: false } },
      { breakpoint: 1025, settings: { dots: false } },
      { breakpoint: 600, settings: { dots: false } },
    ],
    afterChange: updateTabIndex, // 🔥 Fix tabbing issue
  };

  useEffect(() => {
    updateTabIndex();
  }, [customerData]);

const yelpReviews = [
  {
    username: "K G.",
    rating: 5,
    review: "Very nice people. Sounds very knowledgeable. Clean showroom. Great location with off street parking."
  },
  {
    username: "Denise V.",
    rating: 5,
    review: "My ring was returned looking brand spanking new!!! Staff was very professional and efficient."
  },
  {
    username: "Megan N.",
    rating: 5,
    review: "Omi was amazing to work with! He responded quickly to my request for Rhodium re-plating. He originally said it would take a few days, but my ring was done the next day! He even gave my fiancé a quote if we choose to upgrade my ring. The Rhodium looks great and the polishing made my ring look brand new. I will definitely be coming back when it needs to re-plate again or when my partner decides to upgrade it!"
  },
  {
    username: "Kendall A.",
    rating: 5,
    review: "Restoration miracle workers after my Grandmother’s ring found after the wildfire!! Forever grateful!"
  },
  {
    username: "Bob A.",
    rating: 5,
    review: "Omi is a super person to work with. Have had a repair and resizing done (two separate jobs) and both were done quickly and absolutely flawlessly. I won’t be going anywhere else."
  },
  {
    username: "Mavis N.",
    rating: 5,
    review: "The jeweler and his team are terrific. They helped me design and redesign family keepsakes that I adore."
  },
  {
    username: "Tim M.",
    rating: 5,
    review: "While in Maui we went engagement ring shopping and met with Omi. His knowledge and expertise and kindness are amazing. After showing her various rings and getting a sense of what she likes he went into the back and brought out the most beautiful engagement ring. It is flawless. We live in California and he made sure that it was shipped safe and sound. He was always available to talk on the phone and was super helpful regarding updates. I highly recommend Nokaoi jewelers and plan on stopping by just to say hi the next time I am in Maui."
  }
];
const googleReviews = [
  {
    username: "Grant MacDonald",
    rating: 5,
    review: "So happy to find this jewel of a store, I’d given up on repairing my mother’s ring. Other local options gave outrageous quotes and as I drove home I saw this place. Upon going in I was greeted warmly, we talked story and came to an agreement..."
  },
  {
    username: "eleora miller",
    rating: 5,
    review: "I cannot say enough amazing things about my experience at No Ka Oi Jewelry with Omi and his wife! From the moment I walked in, I was made to feel welcomed, valued and completely at ease during such an important purchase..."
  },
  {
    username: "Randi Borge",
    rating: 5,
    review: "My husband and I had the best experience at No Ka ‘Oi Jewelers! The Chamdi’s are very professional, welcoming, and knowledgeable. They helped us pick out wedding bands that matched our individual styles and complemented each other well..."
  },
  {
    username: "Shannon Hoekstra",
    rating: 5,
    review: "Fabulous experience from No Ka ‘Oi Jewelers! Had my engagement ring reset and I am in love with the results. Very friendly, professional and experienced jewelers for all your needs. Also had my watch battery replaced and a ring rhodium plated! Thank you for the beautiful ring!"
  }
];


  return (
    <section className="rcs_customer_say_section">
      <Container fluid className="showcase-container">
        <Row>
          <Col lg={12}>
<div className="text-center pb-3">
          <Heading className="text-center p-0">
            <h2>What People Say</h2>
          </Heading>
        </div>
          </Col>
          </Row>

        <Row>
          <Col lg={6} data-aos="fade-up" data-aos-duration="1400">
            <div className="rcs_customer_review_slider">
              <div className="rcs_customer_slide_title_img mb-4">
                      <div className="rcs_customer_review_slide_img">
                        <LazyLoadImage
                          src={googleImg}
                          alt="Google Review Image"
                          onClick={() => window.open("https://www.google.com/search?num=12&sa=X&sca_esv=4a7abaa8c9d72b6e&q=NO+KA+%E2%80%98OI+JEWELERS&si=AMgyJEtkdv0bUy3jSIkW9mWntMhFklqBoU8Pv9aKe-yCHl3vFvLKF4Jl2yyqh7V4eLtRIiG_EEIRIAocx_9w2tzoD5jCOWYhfx3A47y1UQHlyCfvHs_tvhR82SxLyz2dBkTlRVHs9ZMFNjhbR4oHYZIOX8Jrq3WhoZ9ZWmrBC20BdCv_RGliCvvE_KpnBCP89H1Oy-U5VUQP0POQcuOgF9BQsj_55JWpKiJnfUanosoyHCOrnCX8XQ8%3D&ved=2ahUKEwib8cPPtJaPAxVrr1YBHanxJsQQ6RN6BAgUEAE&biw=1920&bih=911&dpr=1#lrd=0x7954d3a1b72dee83:0x801b3774205a09e,1,,,,", "_blank")}
                        />
                      </div>
                    </div>
              <Slider className="rcs_customer_say_inner" {...settings2}>
                {googleReviews.map((customdata, index) => (
                  <div className="rcs_customer_review_slide_item" key={index}>
                    
                    <div className="rcs_customer_slide_text_content text-center mb-4">
                      <p>{customdata?.review?.slice(0, 150)}{customdata?.review?.length > 150 ? "..." : ""}</p>
                      <Link to="#" onClick={() => window.open("https://www.google.com/search?num=12&sa=X&sca_esv=4a7abaa8c9d72b6e&q=NO+KA+%E2%80%98OI+JEWELERS&si=AMgyJEtkdv0bUy3jSIkW9mWntMhFklqBoU8Pv9aKe-yCHl3vFvLKF4Jl2yyqh7V4eLtRIiG_EEIRIAocx_9w2tzoD5jCOWYhfx3A47y1UQHlyCfvHs_tvhR82SxLyz2dBkTlRVHs9ZMFNjhbR4oHYZIOX8Jrq3WhoZ9ZWmrBC20BdCv_RGliCvvE_KpnBCP89H1Oy-U5VUQP0POQcuOgF9BQsj_55JWpKiJnfUanosoyHCOrnCX8XQ8%3D&ved=2ahUKEwib8cPPtJaPAxVrr1YBHanxJsQQ6RN6BAgUEAE&biw=1920&bih=911&dpr=1#lrd=0x7954d3a1b72dee83:0x801b3774205a09e,1,,,,", "_blank")}>
                        Read More
                      </Link>
                    </div>
                    <div className="rcs_customer_review_footer">
                      <div className="rcs_customer_review_slide_title text-center">
                        <Rating name="half-rating-read" value={customdata?.rating || 5} precision={0.5} size="medium" readOnly />
                        <h3>{customdata?.username}</h3>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
          <Col lg={6} data-aos="fade-up" data-aos-duration="1400">
            <div className="rcs_customer_review_slider">
                <div className="rcs_customer_slide_title_img mb-4">
                      <div className="rcs_customer_review_slide_img">
                        <LazyLoadImage
                          src={yelpImg}
                          alt="Google Review Image"
                          onClick={() => window.open("https://www.yelp.com/biz/nokaoi-jewelers-kahului-2", "_blank")}
                        />
                      </div>
                    </div>
              <Slider className="rcs_customer_say_inner" {...settings2}>
                {yelpReviews.map((customdata, index) => (
                  <div className="rcs_customer_review_slide_item" key={index}>
                    <div className="rcs_customer_slide_text_content text-center mb-4">
                      <p>{customdata?.review?.slice(0, 150)}{customdata?.review?.length > 150 ? "..." : ""}</p>
                      <Link to="#" onClick={() => window.open("https://www.yelp.com/biz/nokaoi-jewelers-kahului-2", "_blank")}>
                        Read More
                      </Link>
                    </div>
                    <div className="rcs_customer_review_footer">
                      <div className="rcs_customer_review_slide_title text-center">
                        <Rating name="half-rating-read" value={customdata?.rating || 5} precision={0.5} size="medium" readOnly />
                        <h3>{customdata?.username}</h3>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>
       
      </Container>
    </section>
  );
};

export default Customer;
